import { NgModule } from "@angular/core";

import { FileDownloadService } from "./file-download.service";
import { EqualValidator } from "./validation/equal-validator.directive";
import { PasswordComplexityValidator } from "./validation/password-complexity-validator.directive";
import { MinValueValidator } from "./validation/min-value-validator.directive";
import { ButtonBusyDirective } from "./button-busy.directive";
import { AutoFocusDirective } from "./auto-focus.directive";
import { BusyIfDirective } from "./busy-if.directive";
import { LocalStorageService } from "./local-storage.service";
import { FriendProfilePictureComponent } from "./friend-profile-picture.component";
import { MomentFormatPipe, LocalDateTimePipe } from "./moment-format.pipe";
import { CurrencyInputDirective } from "./currency-input.directive";
import { NormalizeDropdownPositionDirective } from "./normalize-dropdown-position.directive";
import { LazyBgDirective } from "./lazy-bg.directive";

@NgModule({
    providers: [FileDownloadService, LocalStorageService],
    declarations: [
        EqualValidator,
        PasswordComplexityValidator,
        MinValueValidator,
        ButtonBusyDirective,
        AutoFocusDirective,
        BusyIfDirective,
        FriendProfilePictureComponent,
        MomentFormatPipe,
        LocalDateTimePipe,
        CurrencyInputDirective,
        NormalizeDropdownPositionDirective,
       
  
    ],
    exports: [
        EqualValidator,
        PasswordComplexityValidator,
        MinValueValidator,
        ButtonBusyDirective,
        AutoFocusDirective,
        BusyIfDirective,
        FriendProfilePictureComponent,
        MomentFormatPipe,
        LocalDateTimePipe,
        CurrencyInputDirective,
        NormalizeDropdownPositionDirective,
    ],
})
export class UtilsModule {}



// WEBPACK FOOTER //
// ./src/shared/utils/utils.module.ts